import { useState, useEffect, startTransition } from 'react'

const useHydration = (options = { waitForAnimationFrame: false }) => {
  const [isHydrated, setHydrated] = useState(false)
  const [frameExpired, setFrameExpired] = useState(false)
  useEffect(() => {
    startTransition(() => {
      setHydrated(true)
    })
  }, [])
  useEffect(() => {
    window.requestAnimationFrame(() => {
      startTransition(() => {
        setFrameExpired(true)
      })
    })
  }, [])

  if (options.waitForAnimationFrame) {
    return { isHydrated: frameExpired }
  }

  return { isHydrated }
}

export default useHydration
